import {
  NotificationEventType,
  NotificationTransport,
} from "@modules/graphql/types"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"
import { ThemeCss } from "gatsby-interface"

export const getNotificationOptions = (resourceType: string) => {
  if (resourceType === "SITE") {
    return [
      NotificationTransport.OutgoingWebhook,
      NotificationTransport.SlackWebhook,
      NotificationTransport.PullRequestComment,
    ]
  }

  return []
}

export const getNotificationDeploysLabel = (
  keyLabel: NotificationTransport
) => {
  switch (keyLabel) {
    case NotificationTransport.OutgoingWebhook:
      return notificationDeploysText.labels.webhooks

    case NotificationTransport.SlackWebhook:
      return notificationDeploysText.labels.slack

    case NotificationTransport.PullRequestComment:
      return notificationDeploysText.labels.prComment

    default:
      return ""
  }
}

export const getNotificationDeploysStatus = (status: NotificationEventType) => {
  if (status === NotificationEventType.BuildSucceeded) {
    return notificationDeploysText.messages.buildSucceeded
  }

  if (status === NotificationEventType.BuildTimeout) {
    return notificationDeploysText.messages.buildTimeout
  }

  if (status === NotificationEventType.BuildFailed) {
    return notificationDeploysText.messages.buildFailed
  }

  if (status === NotificationEventType.PreviewSucceeded) {
    return notificationDeploysText.messages.previewSucceeded
  }

  if (status === NotificationEventType.PreviewFailed) {
    return notificationDeploysText.messages.previewFailed
  }

  if (status === NotificationEventType.PreviewTimeout) {
    return notificationDeploysText.messages.previewTimeout
  }

  if (status === NotificationEventType.DeploySucceeded) {
    return notificationDeploysText.messages.deploySucceeded
  }

  if (status === NotificationEventType.DeployFailed) {
    return notificationDeploysText.messages.deployFailed
  }

  return ""
}

export const getTextStyleFromStatus = (
  status: NotificationEventType
): ThemeCss => {
  return theme => {
    if (
      [
        NotificationEventType.BuildSucceeded,
        NotificationEventType.PreviewSucceeded,
        NotificationEventType.DeploySucceeded,
      ].includes(status)
    ) {
      return { color: theme.colors.green[50] }
    }

    if (
      [
        NotificationEventType.BuildFailed,
        NotificationEventType.BuildTimeout,
        NotificationEventType.DeployFailed,
        NotificationEventType.PreviewFailed,
        NotificationEventType.PreviewTimeout,
      ].includes(status)
    ) {
      return { color: theme.colors.red[50] }
    }

    return { color: theme.colors.purple[50] }
  }
}
